/**
 * For values handled with CurrencyInput,
 * strips out commas to send to backend as a float point number.
 * @param value string
 * @returns number
 */
export function currencyToNumber(value: string) {
    return parseFloat(value.replace(/,/g, ''))
}